__turbopack_context__.v({
  "contactContainer": "contact-area-module-scss-module__x3Em-q__contactContainer",
  "contentRow": "contact-area-module-scss-module__x3Em-q__contentRow",
  "emailIcon": "contact-area-module-scss-module__x3Em-q__emailIcon",
  "error": "contact-area-module-scss-module__x3Em-q__error",
  "expandedSection": "contact-area-module-scss-module__x3Em-q__expandedSection",
  "form": "contact-area-module-scss-module__x3Em-q__form",
  "formContainer": "contact-area-module-scss-module__x3Em-q__formContainer",
  "formGroup": "contact-area-module-scss-module__x3Em-q__formGroup",
  "formRow": "contact-area-module-scss-module__x3Em-q__formRow",
  "header": "contact-area-module-scss-module__x3Em-q__header",
  "headerRow": "contact-area-module-scss-module__x3Em-q__headerRow",
  "heading": "contact-area-module-scss-module__x3Em-q__heading",
  "infoContainer": "contact-area-module-scss-module__x3Em-q__infoContainer",
  "input": "contact-area-module-scss-module__x3Em-q__input",
  "inputError": "contact-area-module-scss-module__x3Em-q__inputError",
  "kontakt": "contact-area-module-scss-module__x3Em-q__kontakt",
  "labelName": "contact-area-module-scss-module__x3Em-q__labelName",
  "rotated": "contact-area-module-scss-module__x3Em-q__rotated",
  "socialIcons": "contact-area-module-scss-module__x3Em-q__socialIcons",
  "submitButton": "contact-area-module-scss-module__x3Em-q__submitButton",
  "text": "contact-area-module-scss-module__x3Em-q__text",
  "textarea": "contact-area-module-scss-module__x3Em-q__textarea",
  "textareaError": "contact-area-module-scss-module__x3Em-q__textareaError",
  "threeLineEllipse": "contact-area-module-scss-module__x3Em-q__threeLineEllipse",
  "toggleButton": "contact-area-module-scss-module__x3Em-q__toggleButton",
  "wirFreuenUns": "contact-area-module-scss-module__x3Em-q__wirFreuenUns",
  "wirFreuenUnsWrapper": "contact-area-module-scss-module__x3Em-q__wirFreuenUnsWrapper",
});
